import Resources from '@/scripts/libs/resources'
import wcs from '@/scripts/libs/wcs'
import { getOrderIdFromDocument } from '@/scripts/libs/data'
import axios from 'axios'
import { KlarnaRequest, KlarnaResponse } from './types/klarna-express'
import {
  ACTION_SET_KLARNA_EPXRESS_INITIALIZED,
  ACTION_SET_KLARNA_EXPRESS_LOADED_STATUS,
} from '@/scripts/store/actions'
import QueryString from 'qs'
import { WcsLocales } from './types/locales'

const { klarnaExpress, storeId, langId, catalogId } = wcs.getStoreConfig()

export interface postParamsD extends KlarnaResponse {
  storeId: string
  langId: string
  catalogId: string
  orderId: string
  jsonView?: boolean
}

class KlarnaExpress {
  static initKlarnaExpress = function ({
    vuexStore,
    trackAnalyticsClick,
    isMobile,
  }: {
    vuexStore: any
    trackAnalyticsClick: () => void
    isMobile: boolean
  }): void {
    vuexStore.dispatch(ACTION_SET_KLARNA_EPXRESS_INITIALIZED, false)

    if (!vuexStore.getters.klarnaExpressScriptIsLoaded) {
      Resources.loadResourcesWithCallback({
        resources: [{ src: klarnaExpress.scriptUrl }],
        callback: () => {
          vuexStore.dispatch(ACTION_SET_KLARNA_EXPRESS_LOADED_STATUS, true)

          window.klarnaAsyncCallback = KlarnaExpress.klarnaAsyncCallback({
            vuexStore,
            trackAnalyticsClick,
            isMobile,
          })
        },
        attributes: {
          'data-environment': klarnaExpress.environment,
          'data-id': klarnaExpress.merchantId,
        },
      })
    } else {
      vuexStore.dispatch(ACTION_SET_KLARNA_EXPRESS_LOADED_STATUS, true)
      window.klarnaAsyncCallback = KlarnaExpress.klarnaAsyncCallback({
        vuexStore,
        trackAnalyticsClick,
        isMobile,
      })
    }
  }

  static klarnaAsyncCallback = function ({
    vuexStore,
    trackAnalyticsClick,
    isMobile,
  }: {
    vuexStore: any
    trackAnalyticsClick: () => void
    isMobile: boolean
  }) {
    const klarnaEndpoint = wcs.getEndPoint('klarnaExpressCheckout')
    const { locale } = wcs.getStoreConfig()
    const sanitazedLocale = WcsLocales.getSanitizedLocale(locale)

    window.Klarna.Payments.Buttons.init({
      client_id: klarnaExpress.clientKey,
    }).load(
      {
        container: '#rb-klarna-express',
        theme: 'outlined',
        shape: 'rect',

        locale: sanitazedLocale,

        on_click: async (authorize: any) => {
          const orderId = getOrderIdFromDocument()

          const response = await axios.post(
            '/AjaxCreateKlarnaSession',
            QueryString.stringify({ orderId })
          )

          const payload = response.data.payload

          const sessionForKlarna = JSON.parse(payload)

          authorize(
            { collect_shipping_address: true },
            sessionForKlarna,
            async (result: KlarnaRequest) => {
              if (!result.approved || result.error) {
                return
              }

              const dataResult = KlarnaExpress.normalizeResult(result)

              const postParams: postParamsD = {
                ...dataResult,
                storeId,
                langId,
                catalogId,
                orderId,
              }
              if (isMobile) {
                postParams.jsonView = true
              }
              const response = await axios.post(klarnaEndpoint, QueryString.stringify(postParams))
              const redirectUrl = response.data.redirecturl
              window.location.href = redirectUrl.replace(/&amp;/g, '&')
            }
          )

          trackAnalyticsClick()
        },
      },
      function load_callback() {
        vuexStore.dispatch(ACTION_SET_KLARNA_EPXRESS_INITIALIZED, true)
      }
    )
  }

  static normalizeResult(result: KlarnaRequest): KlarnaResponse {
    const collectedShippingAddress = result.collected_shipping_address

    const normalizedKlarnaResponse: KlarnaResponse = {
      klarna_auth_token: result.authorization_token,
      attention: collectedShippingAddress.attention ?? '',
      city: collectedShippingAddress.city,
      country: collectedShippingAddress.country,
      email: collectedShippingAddress.email,
      lastName: collectedShippingAddress.family_name,
      firstName: collectedShippingAddress.given_name,
      organizationName: '',
      phone: collectedShippingAddress.phone,
      postalCode: collectedShippingAddress.postal_code,
      region: collectedShippingAddress.region,
      address1: collectedShippingAddress.street_address,
      address2: '',
      title: '',
      sessionId: result.session_id,
    }

    return normalizedKlarnaResponse
  }
}

export default KlarnaExpress
